export const ApiErrorCodeMap = {
  generic: 'Something went wrong. Try again.',
  101: 'The serial received ID does not exist.',
  102: 'Serial number can not be empty.',
  103: 'Serial number can not be longer than 255 characters.',
  104: 'Serial number already exists for this item on this purchase order.',
  105: 'Purchase order does not have the item ID.',
  106: 'Can not update serialized received ID since it has already been added to inventory.',
  107: 'Purchase order line ID does not exist.',
  108: 'Purchase order does not have the orderLine that contains the item.',
  109: 'Purchase order is finished.',
  110: 'Purchase order is not check-in yet.',
};
